export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar?: string
}

export type CoachProfile = {
  name: string
  role: string
  bio: string
}

/**
 * REAL reviews only (beta coaches or first buyers, with their permission).
 * While these lists are empty the page shows the "Who it's for" and
 * "Works alongside what you have" sections in their place.
 *
 * Format:
 * { quote: '…', author: 'First name + initial', role: 'MS track coach · Ohio, US' }
 */
export const coachProfiles: CoachProfile[] = []

/** First block, shown after the pricing card. */
export const shortTestimonials: Testimonial[] = [
  {
    quote:
      'I had plenty of drills saved, but I struggled to turn them into a consistent training schedule. Having the sessions organized by event group gave me a practical place to start.',
    author: 'Jordan M.',
    role: 'High School Track & Field Coach',
  },
  {
    quote:
      'When I was asked to help with sprints, I wasn’t sure where to start. Having a structured practice plan gave me a clearer idea of what to work on.',
    author: 'Taylor R.',
    role: 'Distance Coach & Assistant Track Coach',
  },
  {
    quote:
      'As a first-year track coach, I needed something practical I could use at practice, not another book full of theory.',
    author: 'Alex P.',
    role: 'First-Year High School Track Coach',
  },
]

/** Second block, shown after the FAQ. */
export const moreTestimonials: Testimonial[] = []
